/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Forgot_LinkInputs */

const es_co2_password_forgot_link = /** @type {(inputs: Password_Forgot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olvidé mi contraseña`)
};

/**

* @param {Password_Forgot_LinkInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const password_forgot_link = /** @type {((inputs?: Password_Forgot_LinkInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Forgot_LinkInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_password_forgot_link(inputs)
});